import { useQueryClient } from '@tanstack/react-query';

import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { CompleteTotpRequest, CompleteTotpResponse } from '../../../../../shared/types/routes/auth/mfa';

import { getMfaMethodsQueryKey } from './useListMfaMethods';

/**
 * Verify code and save method
 */
export default function useCompleteTotpSetup() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (request: CompleteTotpRequest) => {
      return post<CompleteTotpRequest, CompleteTotpResponse>('/api/auth/mfa/totp/verify', request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getMfaMethodsQueryKey() });
    },
    successToastMessage: 'MFA setup completed successfully',
    errorToastMessage: 'Failed to complete MFA setup. Please check your code and try again.',
  });
}
